import { ElMessage } from 'element-plus'

export const useUtils = () => {
    /** 成功提示 */
    const err_msg = (title: any) => ElMessage({ message: title, type: "error" })
    /** 失败提示 */
    const suc_msg = (title: any) => ElMessage({ message: title, type: "success" })
    /** 
     * 富文本预处理
     * @example const richText = `<img >`
     *          processRichTextImages(richText, { maxWidth: '100%',})
     */
    function processRichTextImages(htmlContent: string, options: any = {}) {
        if (!htmlContent) return htmlContent

        const {
            maxWidth = '100%',
            height = 'auto',
            addClass = true,
            className = 'rich-text-img'
        } = options

        try {
            // 创建临时容器
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = htmlContent

            // 处理所有图片
            const images = tempDiv.querySelectorAll('img')

            images.forEach(img => {
                // 检查是否应该跳过（已有特定样式或类）
                if (img.classList.contains('no-resize') || img.style.maxWidth) {
                    return
                }

                // 设置样式
                img.style.maxWidth = maxWidth
                img.style.height = height

                // 添加类名
                if (addClass) {
                    img.classList.add(className)
                }
            })

            return tempDiv.innerHTML
        } catch (error) {
            console.error('处理富文本图片失败:', error)
            return htmlContent
        }
    }

    /** 表单认证 */
    function validate(value: any, vtype: any) {
        if ('password' === vtype) {
            return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/.test(value);
        }
        if ('phone' == vtype) {
            return /^1[3-9]\d{9}$/.test(value)
        }
        if ('idCard' == vtype) {
            return /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
        }
        if ('email' == vtype) {
            return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
        }
        if ('require' == vtype) {
            return String(value).trim()
        }
    }

    function getLocalIP(): Promise<string> {
        return new Promise((resolve, reject) => {
            const pc = new RTCPeerConnection({
                iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
            });

            pc.createDataChannel("");
            pc.createOffer().then(offer => pc.setLocalDescription(offer));

            pc.onicecandidate = (e) => {
                if (!e.candidate) return;
                const ip = /([0-9]{1,3}\.){3}[0-9]{1,3}/.exec(e.candidate.candidate)?.[0];
                if (ip && !ip.startsWith("192.")) {
                    resolve(ip);
                    pc.close();
                }
            };

            setTimeout(() => reject("timeout"), 5000);
        });
    }

    // getLocalIP().then(ip => console.log("IP:", ip));

    return { err_msg, suc_msg, processRichTextImages, validate, getLocalIP }
}

